import { useEffect, useMemo } from "react";
import { useI18n } from "@lookiero/i18n-react";
import { isValueNumberValidation } from "../../../../../../projection/question/question.typeguards";
import { useAnswersValidation } from "./useAnswersValidation";
const useQuestionValidationError = ({ domain, questionId, ref, enabled = true, segment, }) => {
    const { formatMessage } = useI18n({ domain });
    const { scrollToError, validation } = useAnswersValidation();
    const questionValidation = useMemo(() => validation?.find((v) => v.questionId === questionId), [questionId, validation]);
    const { mandatory, value, ctaTriggered, triggerScrollTimestamp } = questionValidation || {};
    const error = useMemo(() => (enabled || ctaTriggered) && value
        ? isValueNumberValidation(value)
            ? formatMessage({ id: value.errorTranslationKey }, { min: `${value.minNumber}`, max: `${value.maxNumber}`, segment: segment.toLowerCase() })
            : formatMessage({ id: value.errorTranslationKey }, { min: `${value.minDate}`, max: `${value.maxDate}`, segment: segment.toLowerCase() })
        : mandatory && ctaTriggered
            ? formatMessage({ id: mandatory.mandatoryErrorTranslationKey }, { segment: segment.toLowerCase() })
            : undefined, [ctaTriggered, enabled, formatMessage, mandatory, segment, value]);
    useEffect(() => {
        if (!triggerScrollTimestamp) {
            return;
        }
        scrollToError(ref);
    }, [ref, scrollToError, triggerScrollTimestamp]);
    return error;
};
export { useQuestionValidationError };
